function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:currentColor;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:currentColor;}\n\t.st3{fill:currentColor;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M61.5,63.8c0.1,2.5,1.2,9.8,4.7,12.9c1.2,1.1,2.7,1.6,4.4,1.4c1.5-0.1,2.7-0.7,3.7-1.9c3.3-4,3.3-12.8,3-15.9   c0-0.3-0.3-10.8-7.5-17.3C61,52,61.5,63.7,61.5,63.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.7,55.7c-2,5.9-1.6,11.5,1.1,16.6c2.1,3.8,4.2,5.9,6.1,5.9c0,0,0,0,0,0c2.6,0,5.5-4,6.5-5.8   c0.3-0.6,7.2-15.8-5.9-28.9C27.5,46.4,24.4,50.8,22.7,55.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.4,44.2c-9.3-18-25-10.4-25.3-10.2c-1.3,0.8-2.4,1.6-3.5,2.4c-8.8-5.5-19.2-5.2-19.7-5.1c-0.4,0-9.2,0.4-16.3,3.5   c-0.9,0.4-1.9,1-3,1.8c-5.2-4-10.3-5.6-15.3-4.5c-9.1,1.9-14,11.7-14.2,12.1C0.5,45.4,1,47,2.3,47.6c1.3,0.6,2.8,0.1,3.4-1.2   c0-0.1,4-8,10.6-9.3c3.2-0.7,6.7,0.3,10.3,3c-3.4,3.5-6.8,8.3-8.8,14c-2.5,7.2-2,14.4,1.4,20.7c3.1,5.7,6.7,8.6,10.6,8.6   c0,0,0.1,0,0.1,0c6.4-0.1,10.6-7.8,11-8.7c0.1-0.2,8.7-18.8-6.5-34.5c0.4-0.3,0.8-0.5,1.2-0.6c6.2-2.8,14.3-3.1,14.4-3.1   c0.1,0,8.3-0.3,15.5,3.6c-9.8,10.5-9.3,23.4-9.3,24.1c0,0.5,0.6,11.3,6.5,16.5c2.1,1.8,4.5,2.8,7.3,2.8c0.3,0,0.6,0,0.9,0   c2.9-0.2,5.4-1.5,7.3-3.7c5.4-6.4,4.2-19.2,4.2-19.5c0-0.5-0.3-12.3-8.7-20.4c0.6-0.4,1.2-0.8,1.8-1.2c0.5-0.2,11.2-5.5,18.2,8.1   c0.7,1.3,2.2,1.8,3.5,1.1C98.6,47,99.1,45.5,98.4,44.2z M36.4,72.3c-1,1.9-3.8,5.8-6.5,5.8c0,0,0,0,0,0c-1.9,0-4-2.1-6.1-5.9   c-2.7-5.1-3.1-10.7-1.1-16.6c1.7-4.9,4.8-9.3,7.8-12.3C43.6,56.6,36.7,71.7,36.4,72.3z M77.4,60.3c0.3,3.1,0.3,12-3,15.9   c-1,1.2-2.2,1.8-3.7,1.9c-1.7,0.1-3.2-0.3-4.4-1.4c-3.5-3.1-4.6-10.4-4.7-12.9c0-0.1-0.4-11.8,8.4-20.8C77,49.6,77.4,60,77.4,60.3z   "
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "currentColor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72de27cc.svg";
export { ForwardRef as ReactComponent };